import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtErr } from "../lib/api";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("btf-token", data.token);
            navigate("/admin");
        } catch (err) {
            setError(fmtErr(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] px-6" data-testid="admin-login-page">
            <form onSubmit={submit} className="w-full max-w-sm bg-white p-10">
                <div className="font-display text-4xl leading-[0.85] text-[#0A0A0A]">
                    BEYOND
                    <br />
                    THE FIELD<span className="text-[#D60024]">+</span>
                </div>
                <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-neutral-400">Admin</p>
                <div className="mt-8 space-y-4">
                    <input
                        type="email"
                        required
                        data-testid="admin-email-input"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full rounded-none border border-neutral-300 px-4 py-3 text-sm outline-none focus:border-[#D60024]"
                    />
                    <input
                        type="password"
                        required
                        data-testid="admin-password-input"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full rounded-none border border-neutral-300 px-4 py-3 text-sm outline-none focus:border-[#D60024]"
                    />
                    {error && <p data-testid="admin-login-error" className="text-xs font-medium text-[#D60024]">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="w-full bg-[#0A0A0A] py-3.5 text-xs font-semibold uppercase tracking-[0.25em] text-white transition-colors hover:bg-[#D60024] disabled:opacity-50"
                    >
                        {loading ? "…" : "Sign in +"}
                    </button>
                </div>
                <a href="/" className="mt-6 block text-center text-[11px] uppercase tracking-[0.2em] text-neutral-400 hover:text-[#D60024]">← Back to site</a>
            </form>
        </div>
    );
}
